/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

/* ===============================
   Discount field logic
   - Generic discount codes
   - Special EASTERGIFT handling
   - Drawer: reload current page
   - Cart page: redirect to /cart
================================= */
(function () {
  if (window.CartDiscountField) return;

  window.CartDiscountField = {
    GIFT_CODE: 'EASTERGIFT',
    GIFT_VARIANT_ID: 18510498070579,
    GIFT_SKU: 'L-AVOCADO-UNIT',
    MINIMUM_AMOUNT_CENTS: 6000,

    getStrings(root) {
      return {
        enterCode: root.dataset.enterCodeText || 'Please enter a code.',
        invalidCode: root.dataset.invalidCodeText || 'This code is not valid.',
        minimumNotReached: root.dataset.minimumNotReachedText || 'This reward requires a minimum order amount.',
        applyError: root.dataset.applyErrorText || 'Something went wrong. Please try again.',
        removeError: root.dataset.removeErrorText || 'We could not remove the code. Please try again.'
      };
    },

    async getCart() {
      return fetch('/cart.js', {
        credentials: 'same-origin'
      }).then(r => r.json());
    },

    async updateCartAttributes(attributes) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes })
      });
    },

    async addGift() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [
            {
              id: this.GIFT_VARIANT_ID,
              quantity: 1
            }
          ]
        })
      });
    },

    async removeGift(cart) {
      const gift = cart.items.find(item =>
        item.variant_id === this.GIFT_VARIANT_ID || item.sku === this.GIFT_SKU
      );

      if (!gift) return;

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: gift.key,
          quantity: 0
        })
      });
    },

    isDrawer(element) {
      return !!element.closest('cart-drawer');
    },

    currentPageRedirectUrl() {
      return window.location.pathname + window.location.search;
    },

    setMessage(messageEl, text, type) {
      if (!messageEl) return;
      messageEl.textContent = text || '';
      messageEl.classList.remove('is-error', 'is-success');
      if (type) messageEl.classList.add(type);
    },

    async validateNormalCode(code) {
      try {
        const beforeCart = await this.getCart();
        const beforeTitles = (beforeCart.cart_level_discount_applications || []).map(d => (d.title || '').toUpperCase());

        await fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart', {
          credentials: 'same-origin'
        });

        const afterCart = await this.getCart();
        const afterTitles = (afterCart.cart_level_discount_applications || []).map(d => (d.title || '').toUpperCase());

        return afterTitles.includes(code) || (!beforeTitles.includes(code) && afterTitles.length > beforeTitles.length);
      } catch (e) {
        return false;
      }
    },

    async apply(button) {
      const root = button.closest('[data-cart-discount-field]');
      if (!root) return;

      const input = root.querySelector('.cart-discount__input');
      const message = root.querySelector('[data-cart-discount-message]');
      const code = (input?.value || '').trim().toUpperCase();
      const inDrawer = this.isDrawer(root);
      const strings = this.getStrings(root);

      this.setMessage(message, '');

      if (!code) {
        this.setMessage(message, strings.enterCode, 'is-error');
        return;
      }

      if (code === this.GIFT_CODE) {
        try {
          const cart = await this.getCart();

          if (cart.total_price < this.MINIMUM_AMOUNT_CENTS) {
            this.setMessage(message, strings.minimumNotReached, 'is-error');
            return;
          }

          const alreadyInCart = cart.items.some(item =>
            item.variant_id === this.GIFT_VARIANT_ID || item.sku === this.GIFT_SKU
          );

          await this.updateCartAttributes({
            easter_reward_code: code
          });

          if (!alreadyInCart) {
            await this.addGift();
          }

          if (inDrawer) {
            window.location.href =
              '/discount/' + encodeURIComponent(code) +
              '?redirect=' + encodeURIComponent(this.currentPageRedirectUrl());
            return;
          }

          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
          return;

        } catch (error) {
          this.setMessage(message, strings.applyError, 'is-error');
          return;
        }
      }

      if (inDrawer) {
        const valid = await this.validateNormalCode(code);

        if (!valid) {
          this.setMessage(message, strings.invalidCode, 'is-error');
          return;
        }

        window.location.href =
          '/discount/' + encodeURIComponent(code) +
          '?redirect=' + encodeURIComponent(this.currentPageRedirectUrl());
        return;
      }

      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    },

    async remove(button) {
      const root = button.closest('[data-cart-discount-field]');
      if (!root) return;

      const message = root.querySelector('[data-cart-discount-message]');
      const inDrawer = this.isDrawer(root);
      const strings = this.getStrings(root);

      this.setMessage(message, '');

      try {
        const cart = await this.getCart();

        const hasGift = cart.items.some(item =>
          item.variant_id === this.GIFT_VARIANT_ID || item.sku === this.GIFT_SKU
        );

        if (hasGift) {
          await this.removeGift(cart);
        }

        await this.updateCartAttributes({
          easter_reward_code: ''
        });

        if (inDrawer) {
          window.location.href =
            '/discount/none?redirect=' + encodeURIComponent(this.currentPageRedirectUrl());
          return;
        }

        window.location.href = '/discount/none?redirect=/cart';

      } catch (error) {
        this.setMessage(message, strings.removeError, 'is-error');
      }
    }
  };
})();

/* ===============================
   Discount Hunt -> Klaviyo bridge (US)
   - Detect reward popup
   - Save code in localStorage
   - Copy code to clipboard
   - Open Klaviyo form automatically
================================= */
(function () {
  const ROOT_SELECTOR = '#discounthuntapp-root';
  const CODE_SELECTOR = '#ff-discounthunt-session-modal__body ._resultDiscountCode_yj2h2_25';

  const STORAGE_CODE = 'oc_discount_hunt_code';
  const STORAGE_LAST_TRIGGERED = 'oc_discount_hunt_last_triggered';

  const REWARD_CONFIG = {
    EASTER15: {
      formId: 'XA2ccE',
      type: 'discount',
      minimum: 'Valid on orders over $60'
    },
    EASTER10: {
      formId: 'XYddSm',
      type: 'discount',
      minimum: 'Valid on orders over $60'
    },
    EASTERGIFT: {
      formId: 'Siyi7j',
      type: 'gift',
      minimum: 'Valid on orders over $60'
    }
  };

  function saveReward(code) {
    const reward = REWARD_CONFIG[code];
    if (!reward) return;

    localStorage.setItem(STORAGE_CODE, code);
    localStorage.setItem('oc_discount_hunt_reward_type', reward.type);
    localStorage.setItem('oc_discount_hunt_reward_minimum', reward.minimum);
  }

  async function copyCode(code) {
    if (!code) return;

    try {
      await navigator.clipboard.writeText(code);
    } catch (e) {
      // silent fail
    }
  }

  function openKlaviyoForm(formId) {
    if (!formId) return;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  function openKlaviyoFormWithRetry(formId, retries = 6, delay = 400) {
    if (!formId) return;

    let attempts = 0;

    function tryOpen() {
      attempts += 1;
      openKlaviyoForm(formId);

      if (attempts < retries) {
        setTimeout(tryOpen, delay);
      }
    }

    tryOpen();
  }

  function handleDiscountHuntPopup(root) {
    if (!root) return;

    const codeEl = root.querySelector(CODE_SELECTOR);
    if (!codeEl) return;

    const code = (codeEl.textContent || '').trim().toUpperCase();
    if (!code) return;

    const reward = REWARD_CONFIG[code];
    if (!reward || !reward.formId) return;

    const lastTriggered = sessionStorage.getItem(STORAGE_LAST_TRIGGERED);
    if (lastTriggered === code) return;

    sessionStorage.setItem(STORAGE_LAST_TRIGGERED, code);

    saveReward(code);
    copyCode(code);
    openKlaviyoFormWithRetry(reward.formId);
  }

  function initDiscountHuntObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          const popupRoot =
            node.matches?.(ROOT_SELECTOR)
              ? node
              : node.querySelector?.(ROOT_SELECTOR);

          if (popupRoot) {
            handleDiscountHuntPopup(popupRoot);
            return;
          }

          const codeEl = node.matches?.(CODE_SELECTOR)
            ? node
            : node.querySelector?.(CODE_SELECTOR);

          if (codeEl) {
            handleDiscountHuntPopup(document);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiscountHuntObserver);
  } else {
    initDiscountHuntObserver();
  }
})();